import type { Block } from '../../../../types/proposal-blocks';

type Data = Extract<Block, { type: 'milestones' }>;

const statusStyles: Record<string, string> = {
  pendiente: 'bg-yellow-400/15 text-yellow-400',
  en_curso: 'bg-blue-400/15 text-blue-400',
  entregado: 'bg-[rgba(182,255,60,0.15)] text-proposal-accent',
};

const statusLabels: Record<string, string> = {
  pendiente: 'PENDIENTE',
  en_curso: 'EN CURSO',
  entregado: 'ENTREGADO',
};

export function MilestonesBlock({ block }: { block: Data }) {
  return (
    <div className="my-6">
      {block.metrics.length > 0 && (
        <div className="flex gap-4 mb-8 flex-wrap">
          {block.metrics.map((m, i) => (
            <div key={i} className="bg-proposal-bg2 border border-proposal-border rounded-p-lg px-6 py-5 flex-1 min-w-[120px]">
              <div className="text-[28px] font-bold text-proposal-fg1 font-proposal-mono leading-none mb-1">{m.value}</div>
              <div className="text-[12px] text-proposal-fg3 uppercase tracking-wide">{m.label}</div>
            </div>
          ))}
        </div>
      )}
      <div className="overflow-x-auto border border-proposal-border rounded-p-lg">
        <table className="w-full border-collapse text-[13px]">
          <thead>
            <tr>
              <th className="bg-proposal-bg2 text-proposal-fg3 text-[11px] font-semibold uppercase tracking-wide px-3.5 py-2.5 text-left border-b border-proposal-border">Status</th>
              <th className="bg-proposal-bg2 text-proposal-fg3 text-[11px] font-semibold uppercase tracking-wide px-3.5 py-2.5 text-left border-b border-proposal-border">ID</th>
              <th className="bg-proposal-bg2 text-proposal-fg3 text-[11px] font-semibold uppercase tracking-wide px-3.5 py-2.5 text-left border-b border-proposal-border">Hito</th>
              <th className="bg-proposal-bg2 text-proposal-fg3 text-[11px] font-semibold uppercase tracking-wide px-3.5 py-2.5 text-left border-b border-proposal-border">Fecha</th>
              <th className="bg-proposal-bg2 text-proposal-fg3 text-[11px] font-semibold uppercase tracking-wide px-3.5 py-2.5 text-left border-b border-proposal-border">Importe</th>
            </tr>
          </thead>
          <tbody>
            {block.items.map((m) => (
              <tr key={m.id} className="hover:bg-proposal-bg2/50">
                <td className="px-3.5 py-2.5 border-b border-proposal-border">
                  <span className={`inline-flex items-center gap-1 font-proposal-mono text-[11px] font-semibold px-2 py-0.5 rounded ${statusStyles[m.status || 'pendiente'] || statusStyles.pendiente}`}>
                    ● {statusLabels[m.status || 'pendiente'] || 'PENDIENTE'}
                  </span>
                </td>
                <td className="px-3.5 py-2.5 border-b border-proposal-border font-proposal-mono text-[11px] text-proposal-fg3">{m.id}</td>
                <td className="px-3.5 py-2.5 border-b border-proposal-border text-proposal-fg1">{m.title}</td>
                <td className="px-3.5 py-2.5 border-b border-proposal-border font-proposal-mono text-[12px] text-proposal-fg2">{m.date || '—'}</td>
                <td className="px-3.5 py-2.5 border-b border-proposal-border font-proposal-mono font-semibold">{m.amount || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
